import { DetailsControlType } from 'shared/details-page/details-control/details-control-type';
import { Observable } from 'rxjs';


export const collapseWidth = 83;
export const collapseWidthPx = `${collapseWidth}px`;
export const colWidthPx = `calc(25% - ${collapseWidth / 4}px)`;

export const rowData: Array<any> = [
  {
    fieldName: 'brandLabel',
    width: colWidthPx,
    typeahead: true,
    title: 'Brand',
  }, {
    fieldName: 'partNumber',
    width: colWidthPx,
  }, {
    fieldName: 'typeCode',
    width: colWidthPx,
    type: DetailsControlType.Select,
  }, {
    fieldName: 'qualityGradeLevel',
    width: colWidthPx,
    type: DetailsControlType.Select,
  },
];

export const contentData: Array<any> = [
  [{
    fieldName: 'subBrandId',
    width: '50%',
    type: DetailsControlType.Select,
    apiLookup: true,
  }, {
    fieldName: 'languageCode',
    width: '50%',
    type: DetailsControlType.Select,
  }], [{
    fieldName: 'interchangeNotes',
    width: '100%',
    type: DetailsControlType.Textarea,
  }], [{
    fieldName: 'internalNotes',
    width: '100%',
    type: DetailsControlType.Textarea,
  }],
];
